.container {
    min-height: 60vh;
    background-color: #0a0b0d;
    background-image: linear-gradient(to bottom, #17181c 0px, #0e0f12 320px, #0a0b0d 720px);
    background-repeat: no-repeat;
}

.titleContainer {
    position: relative;
    overflow: hidden;
    display: flex;
    height: 760px;
    justify-content: flex-start;
    align-items: center;
}

.titleContainerMob {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 760px;
    justify-content: center;
    align-items: center;
}

/* --- hero background layer --- */
.heroBg {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
}

.heroSvg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.heroFade {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 280px;
    background: linear-gradient(to bottom, rgba(10, 11, 13, 0) 0%, #0a0b0d 88%);
}

/* --- hero text --- */
.title {
    font-size: 5.3em;
    font-family: var(--font-display);
    margin: 0;
    color: #ffffff;
    text-align: justify;
    font-weight: 1000;
    letter-spacing: -2px;
    text-shadow: 0 2px 22px rgba(0, 0, 0, 0.6);
}

.description {
    display: block;
    width: fit-content;
    font-family: var(--font-serif);
    font-size: 2em;
    margin-top: 13px;
    font-style: italic;
    color: #e7f6a8;
    font-weight: 500;
    background: rgba(11, 12, 14, 0.72);
    padding: 6px 16px;
    border-radius: 8px;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
}

.heroChip {
    display: inline-block;
    margin-top: 22px;
    padding: 8px 16px;
    border-radius: 8px;
    background: #cdeb00;
    color: #0b0c0e;
    font-size: 14px;
    font-weight: 700;
    font-family: var(--font-body);
}

.titleContent {
    padding-left: 8%;
}

/* the mobile layout is one column, the title block is centered in it */
.titleContentMob {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
    text-align: center;
}

.titleContentMob .title {
    text-align: center;
}

.titleContent, .titleContentMob {
    position: relative;
    z-index: 2;
}

/* --- hero device (welcome screen) --- */
.heroPhone {
    position: absolute;
    left: 70%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 252px;
    height: 546px;
    border-radius: 40px;
    background: #0b0d10;
    border: 3px solid #23262e;
    box-shadow: 0 34px 70px rgba(0, 0, 0, 0.6);
    z-index: 1;
    overflow: hidden;
}

.heroPhoneGlow {
    position: absolute;
    left: 70%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 460px;
    height: 460px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(205, 235, 0, 0.28), rgba(205, 235, 0, 0) 66%);
    z-index: 0;
    pointer-events: none;
}

.heroScreen {
    position: absolute;
    inset: 6px;
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    border-radius: 34px;
    object-fit: cover;
    display: block;
}

.heroNotch {
    position: absolute;
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 22px;
    border-radius: 12px;
    background: #0b0d10;
    z-index: 2;
}

.heroPhoneMob {
    position: relative;
    z-index: 1;
    width: 230px;
    height: 498px;
    border-radius: 38px;
    background: #0b0d10;
    border: 3px solid #23262e;
    box-shadow: 0 24px 50px rgba(0, 0, 0, 0.6);
    margin-top: 24px;
    overflow: hidden;
}

/* --- work description / about --- */
.workDescriptionBox {
    display: flex;
    justify-content: center;
}

.workDescription {
    margin: 0;
    max-width: 500px;
    min-width: 300px;
    font-size: 1em;
    word-spacing: 5px;
    text-align: justify-all;
    line-height: 28px;
    font-family: var(--font-serif);
}

.workDescription strong {
    color: #5b7a00;
}

/* --- AboutProject composite visual --- */
.aboutStage {
    position: relative;
    width: 470px;
    height: 560px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.aboutGlow {
    position: absolute;
    width: 380px;
    height: 380px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(205, 235, 0, 0.4), rgba(205, 235, 0, 0) 68%);
    filter: blur(4px);
}

.aboutPhone {
    position: relative;
    width: 232px;
    height: 504px;
    border-radius: 36px;
    background: #0b0d10;
    border: 3px solid #23262e;
    box-shadow: 0 34px 64px rgba(20, 30, 10, 0.28);
    transform: perspective(1300px) rotateY(-16deg) rotate(1deg);
    overflow: hidden;
}

.aboutNotch {
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 74px;
    height: 20px;
    border-radius: 12px;
    background: #0b0d10;
    z-index: 2;
}

.aboutScreen {
    position: absolute;
    inset: 6px;
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    border-radius: 30px;
    object-fit: cover;
    display: block;
}

.aboutTag {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 13px;
    border-radius: 12px;
    background: #ffffff;
    border: 1px solid #eef0e6;
    box-shadow: 0 14px 30px rgba(30, 40, 10, 0.16);
    color: #3f5200;
    font-size: 13px;
    font-weight: 600;
    font-family: var(--font-body);
    white-space: nowrap;
    z-index: 3;
}

.aboutTag1 {
    top: 6%;
    right: 2%;
}

.aboutTag2 {
    top: 45%;
    right: -4%;
}

.aboutTag3 {
    bottom: 12%;
    left: 0;
}

@media (max-width: 1200px) {
    .titleContainerMob {
        box-sizing: border-box;
        height: auto;
        min-height: 760px;
        padding: 40px 16px;
    }
}

@media (max-width: 600px) {
    .title {
        font-size: 3.4em;
    }

    .description {
        font-size: 1.4em;
    }

    .workDescription {
        min-width: 0;
    }
}
